"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIMPLEX_API_ENDPOINTS = exports.SIMPLEX_API_BASE_PROD = exports.SIMPLEX_API_BASE_SANDBOX = void 0;
exports.SIMPLEX_API_BASE_SANDBOX = "https://sandbox.test-simplexcc.com";
exports.SIMPLEX_API_BASE_PROD = "https://api.simplexcc.com";
exports.SIMPLEX_API_ENDPOINTS = {
    FIAT_CURRENCIES_V2: "/v2/supported_fiat_currencies",
    CRYPTO_CURRENCIES_V2: "/v2/supported_crypto_currencies",
    SUPPORTED_COUNTRIES_V2: "/v2/supported_countries",
    BUY_QUOTE_V2: "/wallet/merchant/v2/quote",
};
//# sourceMappingURL=constants.js.map